var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(_vm.alertText),expression:"alertText"}],attrs:{"alt":"alert","src":require('@/assets/img/icons/icon-alert.svg')}})
}
var staticRenderFns = []

export { render, staticRenderFns }